export const taskUnits = [
    {
        id: 3,
        code: 'seconds',
        label: 'Seconds',
        milliseconds: 1000,
    },
    {
        id: 0,
        code: 'minutes',
        label: 'Minutes',
        milliseconds: 60000,
    },
    {
        id: 1,
        code: 'hours',
        label: 'Hours',
        milliseconds: 3600000,
    },
    {
        id: 2,
        code: 'days',
        label: 'Days',
        milliseconds: 86400000,
    },
];
